export const StudentEventsTranslations = {
  CALENDAR: {
    es: 'Calendario',
    en: 'Calendar',
    cat: 'Calendari',
    eus: 'Kalendarioa',
    pt: 'Calendário'
  },
  MORE_EVENTS_TEXT: {
    es: '+{{num}} Más',
    en: '+{{num}} More',
    cat: '+{{num}} Més',
    eus: '+{{num}} Gehiago',
    pt: '+{{num}} Mais'
  },

  MONTH: {
    es: 'Mes',
    en: 'Month',
    cat: 'Mes',
    eus: 'Hilabetea',
    pt: 'Mês'
  },
  WEEK: {
    es: 'Semana',
    en: 'Week',
    cat: 'Setmana',
    eus: 'Astea',
    pt: 'Semana'
  },
  LIST: {
    es: 'Lista',
    en: 'List',
    cat: 'Llista',
    eus: 'Zerrenda',
    pt: 'Lista'
  },
  DAY: {
    es: 'Día',
    en: 'Day',
    cat: 'Dia',
    eus: 'Eguna',
    pt: 'Dia'
  },
  TODAY: {
    es: 'Hoy',
    en: 'Today',
    cat: 'Avui',
    eus: 'Gaur',
    pt: 'Hoje'
  },
  FILTERS: {
    es: 'Filtros',
    en: 'Filters',
    cat: 'Filtres',
    eus: 'Fitxategiak',
    pt: 'Filtros'
  },
  TAGS: {
    es: 'Formaciones',
    en: 'Training',
    cat: 'Formació',
    eus: 'Ikasgaia',
    pt: 'Formação'
  },
  TEACHER: {
    es: 'Profesor',
    en: 'Teacher',
    cat: 'Professor',
    eus: 'Irakaslea',
    pt: 'Professor'
  },
  CLEAR_FILTERS: {
    es: 'Borrar filtros',
    en: 'Clear filters',
    cat: 'Netejar filtres',
    eus: 'Ezabatu filtrotak',
    pt: 'Limpar filtros'
  },
  PLANIFICATION: {
    es: 'Plan de estudio',
    en: 'Study plan',
    cat: "Pla de l'estudi",
    eus: 'Ikaslearen planifikazioa',
    pt: 'Plano de estudo'
  },
  LIVE_CLASSES: {
    es: 'Clases',
    en: 'Classes',
    cat: 'Classes',
    eus: 'klaseak',
    pt: 'Aulas'
  },
  CONFIGURE_PLANIFICATION: {
    es: 'Configurar planificación',
    en: 'Configure planification',
    cat: 'Configure planificació',
    eus: 'Planifikazioa konfiguratzeko',
    pt: 'Configurar planificação'
  },
  PLANIFICATION_TOOLTIP: {
    es: 'Para visualizar tu planificación debes configurarla',
    en: 'To see your planification you must configure it',
    cat: 'Per veure la teva planificació, has de configurar-la',
    eus: 'Planifikazioa ikusteko, konfiguratu behar duzu',
    pt: 'Para ver a sua planificação, tem de configurá-la'
  },
  SELECT_COURSE: {
    es: 'Curso',
    en: 'Course',
    cat: 'Curs',
    eus: 'Ikaslearen kursua',
    pt: 'Curso'
  },
  SELECT_PROFESSOR: {
    es: 'Profesor',
    en: 'Teacher',
    cat: 'Professor',
    eus: 'Ikaslearen ikasle',
    pt: 'Professor'
  }
};
